import FormActions from '~/form-actions.vue'

export default {
    components: {
        FormActions
    },
    props     : {
        modelId: {
            type   : Number,
            default: null
        },
        value  : {
            type   : Boolean,
            default: false
        },
    },
    data() {
        return {
            url        : this.$getUrl('brands', this.value, this.modelId),
            axiosMethod: this.$getAxiosMethod(this.value, this.modelId),
            forms      : this.$root.$data.forms,
            brands     : [],
            loading    : false,
        }
    },

    beforeCreate() {
        this.$root.$data.forms.fieldReset();
    },

    watch   : {
        '$route.fullPath'(val) {
            //reset data
            this.forms.reset();
            this.brands = []
        }

    },
    created() {
        if(this.axiosMethod === 'patch' || this.modelId)
            this.getData()
    },

    methods: {
        getData() {
            this.loading = true
            this.$root.$data.erp.request.get(this.url, this, (data) => {
                this.brands            = data.brands
                this.forms.id          = this.brands.id
                this.forms.name        = this.brands.name
                this.forms.description = this.brands.description
                this.loading           = false
            });
        },
        postBrand($e) {
            let submitter = $e.submitter.value
            // return null
            this.loading  = true
            this.forms.submit(this.axiosMethod, this.$getUrlForm(this.url), true, this.$root)
                .then(data => {
                    this.loading = false
                    if(this.value) {
                        if(submitter === 'submit-close' || submitter === 'update-close') {
                            this.$emit('input', false)
                        }
                    }
                    this.$axiosPostDialog(data)
                }).catch(error => {
                this.loading = false
            });
        },
        onCancel() {
            this.forms.reset();
        }
    }
}